import Radio from '@mui/material/Radio'
import FormControlLabel from '@mui/material/FormControlLabel'
import { AnswerProps } from '../types'

export default function Answer(props: AnswerProps) {
    return (
        <FormControlLabel
            value={props.ID}
            control={
                <Radio />
            }
            sx={{
                '& span': {
                    fontFamily: 'inherit',
                },
                userSelect: 'none',
            }}
            label={props.label}
            name={`${props.label}-${props.ID}`}
            checked={props.checked}
            onChange={() => props.onChange(props.label)}
            disabled={props.disabled}
        />
    )
}
